import Image from '@/assets/images/panama.jpg';

export default {
  slogan: '¡ Soon we will be closer to you !',
  contactUs: 'Contact us',
  firstTitle: {
    text: 'What We Are',
  },
  secondTitle: {
    text: 'Our Staff',
    sub: 'Our human side',
  },
  thirdTitle: {
    text: 'Our Services',
  },
  fourthTitle: {
    text: 'Allies & Collaborators',
    sub: 'A helping hand at any time',
  },
  fifthTitle: {
    text: 'Come to our Office',
    sub: 'Very close to you',
  },
  linksTitle: {
    text: 'Links of Interest',
    sub: 'For more info',
  },
  firstQuote: 'Morales has turned the already ductile Bolivian democracy into a plasticine with which his hands play as he pleases.',
  secondQuote: 'Morales has turned the already ductile Bolivian democracy into a plasticine with which his hands play as he pleases.',
  companyInfo: [
    {
      image: Image,
      title: 'Our Mision',
      subtitle: 'Optinal Subtitle',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam a incidunt fuga, ducimus nisi iusto ipsum sit deleniti suscipit atque aliquid, velit at? At quasi magni voluptates molestiae aperiam',
    },
    {
      image: Image,
      title: 'Our Vision',
      subtitle: 'Optinal Subtitle',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam a incidunt fuga, ducimus nisi iusto ipsum sit deleniti suscipit atque aliquid, velit at? At quasi magni voluptates molestiae aperiam',
    },
    {
      image: Image,
      title: 'Our Goals',
      subtitle: 'Optinal Subtitle',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam a incidunt fuga, ducimus nisi iusto ipsum sit deleniti suscipit atque aliquid, velit at? At quasi magni voluptates molestiae aperiam',
    },
  ],
  services: ['Work', 'Administration', 'Commercial', 'Procedural', 'Corporate', 'Others'],
  officeInfo: [
    {
      textUp: 'SFC Building - 55 St. Obarrio',
      textBottom: '22nd Floor - C Office',
      icon: 'map-pin',
      iconType: 'fas',
      size: 'left',
      delay: 200,
    },
    {
      textUp: 'Monday to Friday',
      textBottom: '08:00 AM to 05:00 PM',
      icon: 'clock',
      iconType: 'fas',
      size: 'right',
      delay: 400,
    },
    {
      textUp: '+(507) 209 - 4298',
      textBottom: '+(507) 209 - 4297',
      icon: 'phone',
      iconType: 'fas',
      size: 'left',
      delay: 600,
    },
  ],
  language_picker_helper: 'Choose a language',
  languages: {
    spanish: 'Spanish',
    english: 'English',
  },
};
